module.exports = __webpack_public_path__ + "media/images/lb/051-d7cf3380acb1f20bbd7c0c278cbb5903.svg";